/**
 * Edit API key: form domain model.
 *
 * The editable fields of the Edit form (name, scopes, status). Local to
 * `edit-api-key`: the index has no equivalent form (its create flow is a
 * name-only dialog), so this is deliberately NOT shared. Pure, framework-free.
 */

/** The editable API-key form state. */
export interface ApiKeyDraft {
  name: string;
  /** Granted scopes; at least one required. */
  scopes: string[];
  /** Editable status; 'active' | 'revoked' ('' = not loaded yet). */
  status: string;
}

/** A pristine draft; the starting point before the key hydrates. */
export const emptyDraft: ApiKeyDraft = {
  name: '',
  scopes: [],
  status: '',
};

/** Statuses an administrator can set on the Edit form. */
export const EDITABLE_STATUSES = ['active', 'revoked'] as const;

/** Field-keyed validation messages produced by `validateDraft`. */
export type ValidationErrors = Partial<Record<keyof ApiKeyDraft, string>>;
